<template>
	<div>
		<div class="level">
			<div class="level-left">
				<health-services-filter class="level-item" />
				<hospitals-filter class="level-item" />
				<team-type-filter class="level-item" />
				<users-filter class="level-item" />
			</div>
			<div class="level-right">
				<date-filter class="level-item" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
	name: "FiltersHealthServices",
	computed: {
		...mapGetters({
			selectedHealthServices: "reportQueries/healthservices",
			selectedHospitals: "reportQueries/hospitals",
			selectedGroups: "reportQueries/groups"
		})
	},
	watch: {
		selectedHealthServices() {
			this.updateHospitals([]);
			this.updateGroups([]);
			this.updateUsers([]);
		},
		selectedHospitals(value) {
			this.updateGroups([]);
			this.updateUsers([]);
		},
		selectedGroups(value) {
			this.updateUsers([]);
		}
	},
	created() {
		const { id } = this.currentUser;
		this.fetchFilters(id);
		this.fetchHealthServices();
	},
	methods: {
		...mapActions({
			fetchFilters: "reportFilters/fetchUserHospitalGroups",
			fetchHealthServices: "reportFilters/fetchHealthServices",
			updateHospitals: "reportQueries/updateHospitals",
			updateGroups: "reportQueries/updateGroups",
			updateUsers: "reportQueries/updateUsers"
		})
	}
};
</script>
